//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import ToastNotificationItem from './BaseToastNotificationItem.vue';

export default {
  name: 'base-toast-notifications',
  components: {
    ToastNotificationItem,
  },
  computed: {
    ...mapGetters({
      alertMessages: 'notification/alertMessages',
    }),
    showAlertMessages() {
      return Array.isArray(this.currentAlertMessages) && this.currentAlertMessages.length;
    },
  },
  data() {
    return {
      currentAlertMessages: [],
    };
  },
  created() {
    // clone
    this.currentAlertMessages = this.alertMessages.slice();
    this.$store.dispatch('notification/clearAlertMessages');
  },
  watch: {
    alertMessages(newMessages) {
      if (newMessages.length > 0) {
        this.currentAlertMessages = this.alertMessages.slice();
        this.$store.dispatch('notification/clearAlertMessages');
      }
    },
  },
  methods: {
    // when use b-toast need to remove old messages on hidden to avoid errors
    clearMessage(id) {
      this.currentAlertMessages = this.currentAlertMessages.filter(({ messageId }) => messageId === id);
    },
  },
};
